module.exports = __webpack_public_path__ + "mainassets/img/sending.bbe58efc.svg";